<template>
  <ExternalQueryList
      headline="Pages"
      endpoint="/api/v2/content-pages"
      :endpoint-filters="{portal_id: portal.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      @show="contentPage => $router.push(getUrl(contentPage))"
  >
    <template v-slot:default="{ row: contentPage }">
      <td>
        <router-link :to="getUrl(contentPage)">
          {{ contentPage.attributes.name }}
        </router-link>
      </td>

      <td>
        {{ contentPage.attributes.path }}
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/pages/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  props: {
    portal: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 10, text: 'Name'},
        {width: 10, text: 'Path'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(contentPage) {
      return '/portals/' + this.portal.id + '/content/pages/' + contentPage.id + '/edit'
    }
  }
}
</script>
